import { createAction, props } from "@ngrx/store";

export enum SeTimelineComponentActions {
    SET_PATIENT = '[SeTimelineComponent] SetPatient',
    SET_SELECTED_ITEM = '[SeTimelineComponent] SetSelectedItem',
}

export const seTimelineComponentSetPatient =
    createAction(SeTimelineComponentActions.SET_PATIENT, props<{ formType : any; patientId : string; isAllBuSearch ?: boolean; }>());

export const seTimelineComponentSetSelectedItem =
    createAction(SeTimelineComponentActions.SET_SELECTED_ITEM, props<{ formType : any;  selectedItem : any; }>()); // formType retrieved from setPatient

